import { classToPlain, plainToClass } from 'class-transformer';

export class CreatePlayerViewModel {
  points: number = 0;
  ownerId!: string;
  foreignReferenceId!: string;
  isOnDeck!: boolean;
}

export default class PlayerModel {
  static fromJson(json: any) {
    return plainToClass(this, json);
  }

  public toJson() {
    return classToPlain(this);
  }

  id!: string;
  points: number = 0;
  ownerId!: string;
  foreignReferenceId!: string;
  isOnDeck!: boolean;
}
